<template>
  <div>
    <div class="swiper-item">
      <div class="swiper-body">
        <div class="swiper-title">提供有竞争力的解决方案和服务持续为客户创造高价值</div>
        <div class="swiper-line"></div>
        <div class="more" @click="phoneActive = !phoneActive">
          <img src="../../static/images/home_button@2x.png" />
          <span>联系我们</span>
          <div class="phone" @click.stop v-show="phoneActive">0755-13278672 </div>
        </div>
      </div>
      <figure class="swiper-bg"></figure>
    </div>
    <div class="tip">涉及PC网站、移动APP开发、小程序开发、H5开发、系统开发等企业服务</div>
    <div class="body">
      <div class="cases">
        <div class="case" v-for="(item, index) in cases" :key="index" @click="intoDetail(item.id)">
          <img class="case-poster" :src="item.poster">
          <div class="case-title">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        phoneActive: false,
        cases: [{
          id: 1,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_1%402x.png',
          title: '理财分销系统'
        }, {
          id: 2,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_2%402x.png',
          title: '在线理赔小程序'
        }, {
          id: 3,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_3%402x.png',
          title: '智能查勘平台'
        }, {
          id: 4,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_4%402x.png',
          title: '智慧微门户小程序'
        }, {
          id: 5,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_5%402x.png',
          title: '智慧台账系统'
        }, {
          id: 6,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_6%402x.png',
          title: '智慧学院小程序'
        }, {
          id: 7,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_7%402x.png',
          title: '财税云小程序'
        }, {
          id: 8,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_8%402x.png',
          title: '多彩旅游圈小程序'
        }, {
          id: 9,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_9%402x.png',
          title: '智慧旅游景区'
        }, {
          id: 10,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_10%402x.png',
          title: '智慧中医小程序'
        }, {
          id: 11,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_11%402x.png',
          title: '智慧中医管理平台'
        }, {
          id: 12,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_12%402x.png',
          title: '财务自动归档平台'
        }, {
          id: 13,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h268_13%402x.png',
          title: '宝贝星球小程序'
        }]
      }
    },
    methods: {
      intoDetail (id) {
        this.$router.push(`/case/detail?id=${id}`)
      }
    }
  }
</script>
<style scoped>
.swiper-item {
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.swiper-body {
  max-width: 1200px;
  margin: 180px auto 0;
  font-size: 20px;
}
.swiper-title {
  font-size: 2em;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
  font-weight:bold;
  width: 560px;
  line-height: 70px;
}
.swiper-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin-top: 14px;
}
.swiper-bg {
  width: 1920px;
  height: 560px;
  background-size: 1920px 560px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h560px_banner%402x.png');
}
.more {
  width:176px;
  height:48px;
  background:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:18px;
  color:rgba(255,255,255,1);
  margin: 40px 0 0 0;
  cursor: pointer;
  position: relative;
}
.more:hover {
  background:#dc170d;
}
.more img {
  width: 24px;
  height: 24px;
  transform: translateY(1px);
  margin-right: 8px;
}
.phone {
  background-image: url('../../static/images/case_h48_popup@2x.png');
  background-size: 100% 100%;
  position: absolute;
  right: -190px;
  top: 0;
  width: 176px;
  height: 48px;
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip {
  height:80px;
  line-height: 80px;
  background:rgba(41,41,54,1);
  font-size:18px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
  text-align: center;
}
.body {
  background-color: #F7FCFC;
  overflow: hidden;
}
.cases {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  max-width: 1200px;
  margin: 46px auto;
}
.case {
  position: relative;
  margin-bottom: 40px;
  cursor: pointer;
  transition: box-shadow .5s ease;
}
.case:hover {
  box-shadow:0px 4px 32px 0px rgba(96,96,96,0.24);
}
.case-poster {
  width: 286px;
  height: 286px;
}
.case-title {
  position: absolute;
  left: 22px;
  bottom: 14px;
  font-size:20px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
}
@media (max-width: 1199px) and (min-width: 992px){
  .swiper-body {
    padding: 0 50px;
  }
  .cases {
    padding: 0 30px;
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .swiper-body {
    padding: 0 50px;
  }
  .cases {
    padding: 0 30px;
  }
}
@media screen and (max-width: 767px){
  .swiper-body {
    padding: 0 50px;
  }
  .cases {
    padding: 0 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/case.vue